import { render, staticRenderFns } from "./PackageTableList.vue?vue&type=template&id=2896b43e"
import script from "./PackageTableList.vue?vue&type=script&lang=js"
export * from "./PackageTableList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports